import {useRef, useState} from 'react';

import {generateCallback} from '/util/component.util';

export function useRefresh(refreshCachedMetrics: any) {
  const [refreshing, setRefreshing] = useState(false);

  const onRefreshRef = useRef(() => {
    setRefreshing(true);

    refreshCachedMetrics().then(
      generateCallback({func: setRefreshing, params: false}),
    );
  });

  return {refreshing, onRefreshRef: onRefreshRef.current};
}
